module.exports = __webpack_public_path__ + "static/media/beaconManageInventoryHeader.788c6af4.jpg";